<div class = "main-container">
<div class = "middle-section">
  <ion-grid>
      <ion-row class="ion-justify-content-center add-certificates">
          <ion-col size="12">
              <div class="shift-and-contract certificates" *ngIf = "stafferCertificates">

                      <!-- Credential sections that sit above the Vulnerable Sector Check block (COVID) -->
                      <ng-container *ngFor = "let section of sectionsBeforeVsc">
                          <ng-container *ngTemplateOutlet="credentialSection; context: {$implicit: section}"></ng-container>
                      </ng-container>

                    <!-- Vulnerable Sector Check -->
                    <ng-container *ngIf = "showVscSection">
                        <div class="requirement-padding other-certificates">
                            <p class="shift-requirement-font"><b>
                                Vulnerable Sector Check<span class="required" *ngIf="!isWaitlisted"> (Required)</span></b>
                            </p>
                        </div>
                        
                        <div *ngFor = "let certificate of vscCertificates; let i = index" >
                            <div class="requirement-padding not-uploaded" 
                            (click) = "uploadCertificate(certificate.name)"
                            [ngClass]="{'uploaded' : [certState.passed, certState.rejected, certState.pending].includes(getCertificateStatus(certificate.name))}">
                                <p class="shift-requirement-font" [ngClass] = "{'max-width': getCertificateStatus(certificate.name) !== certState.rejected}">{{certificate.displayName || certificate.name}}
                                </p>
                                <div class="button-container">
                                <i class="fa fa-clock" *ngIf="getCertificateStatus(certificate.name) === certState.pending"></i>  
                                <i class="fa fa-check" *ngIf="getCertificateStatus(certificate.name) === certState.passed"></i>
                                <i *ngIf="[certState.missing, certState.deleted].includes(getCertificateStatus(certificate.name))" class="fa fa-arrow-right" aria-hidden="true"></i>
                                
                                <div class =  "rejection-container" *ngIf="getCertificateStatus(certificate.name) === certState.rejected">
                                    <button class = "reupload">Reupload</button>
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </div>
                                </div>
                            </div>

                            <p class = "or-text" *ngIf = "i === 0">Or</p>
                            <p class = "request-letter" *ngIf = "i === 1">Don't know how to apply to VSC? <span class = "hyperlink" (click) = "showVSCRequestPopup()">Click here</span></p>
                        </div>
                    </ng-container>

                      <!-- Remaining credential sections for this contractor's industries -->
                      <ng-container *ngFor = "let section of sectionsAfterVsc">
                          <ng-container *ngTemplateOutlet="credentialSection; context: {$implicit: section}"></ng-container>
                      </ng-container>
              </div>
          </ion-col>
      </ion-row>
  </ion-grid>
</div>
</div>

<!--
  One section of the credential catalog. Which sections reach here is decided by
  CertificateListComponent.buildSections() from the contractor's industries.
-->
<ng-template #credentialSection let-section>
    <div class="requirement-padding" [ngClass]="section.key === 'covid' ? 'covid' : 'other-certificates'">
        <p class="shift-requirement-font"><b>
            {{ section.translateKey ? (section.translateKey | translate) : section.title }}<span class="required" *ngIf = "section.key === 'covid' && isHCW"> (Required)</span></b>
        </p>
    </div>

    <div *ngFor = "let certificate of section.credentials">
        <div class="requirement-padding not-uploaded" 
        (click) = "uploadCertificate(certificate.name)"
        [ngClass]="{'uploaded' : [certState.passed, certState.rejected, certState.pending].includes(getCertificateStatus(certificate.name))}">
            <p class="shift-requirement-font" [ngClass] = "{'max-width': getCertificateStatus(certificate.name) !== certState.rejected}">{{certificate.displayName || certificate.name}}
              <span *ngIf = "certificate.isRequired" class = "required">(Required)</span>
            </p>
            <div class="button-container">
              <i class="fa fa-clock" *ngIf="getCertificateStatus(certificate.name) === certState.pending"></i>  
              <i class="fa fa-check" *ngIf="getCertificateStatus(certificate.name) === certState.passed"></i>
              <i *ngIf="[certState.missing, certState.deleted].includes(getCertificateStatus(certificate.name))" class="fa fa-arrow-right" aria-hidden="true"></i>
                
              <div class =  "rejection-container" *ngIf="getCertificateStatus(certificate.name) === certState.rejected">
                  <button class = "reupload">Reupload</button>
                  <i class="fa fa-times" aria-hidden="true"></i>
              </div>
            </div>
        </div>
    </div>
</ng-template>
